import React from 'react'
import FundsTable from './FundsTable'
import { getFundsApi, getPostFundsApi } from '../../services/apiService'
import { showApiError, showApiSuccess } from '../utilities'

class EditableFunds extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
    this.state.dataSource = []
    this.state.loaded = false
  }

  componentDidMount() {
    getFundsApi()
      .then(json => {
        if (typeof json === 'string') {
          throw new Error(json)
        } else {
          this.setState({ dataSource: json, loaded: true })
        }
      })
      .catch(error => {
        showApiError(error)
      })
  }

  handleSaveEvent(evt) {
    let updatedData = this.state.dataSource 
    getPostFundsApi(updatedData)
      .then(json => {
      if (typeof json === 'string') {
        throw new Error(json)
      } else {
        this.setState({ dataSource: json, loaded: true })
        showApiSuccess("Funds updated successfully!")

      }
    })
      .catch(error => {
        showApiError(error)
      })

  }

  handleAddEvent(evt) {
    const { dataSource } = this.state;
    let newID = dataSource.reduce((acc, val) => {
      return Math.min(val.fundId, acc)
    }, 0)  - 1
    const fund = {
      "fundId": newID,
      "description": '',
      "active": true,
      "organisationId": window.sessionStorage.getItem("OrganisationId"),
      "sortOrder": 0,
    };

    this.state.dataSource.push(fund);
    this.setState(this.state.dataSource);

  }

  handleRowDel(fund) {
    var index = this.state.dataSource.indexOf(fund);
    //let newFunds = this.state.dataSource.splice(index, 1);
    let newFunds = this.state.dataSource.slice();
    newFunds[index].deleted = true;
    this.setState({ dataSource: newFunds })
  };


  handleTableUpdate(evt) {

    let item
    let value
    if (evt.target !== undefined) {
      value = evt.target.name === "active" ? evt.target.checked : evt.target.value
      item = {
        rowid: evt.target.rowid || evt.target.getAttribute("rowid"),
        name: evt.target.name,
        value: value
      }
    } else if (evt.value !== undefined) {
      item = {
        rowid: evt.rowid,
        name: evt.name,
        value: evt.value
      }
    } else {
      //console.error("handleTableUpdate -> something wrong here:")
    }

    //console.log("item: " + item )
    let funds = this.state.dataSource.slice();
    let newFunds = funds.map((fund) => {
      for (let key in fund) {
        if (key === item.name && fund.fundId === parseInt(item.rowid)) {
          fund[key] = item.value;
        }
      }
      return fund
    })

    this.setState({ dataSource: newFunds })

  };

  render() {
    if (!this.state.loaded) {
      return <p>loading...</p>
    }
    return (
      <FundsTable
        title={this.props.title}
        onTableUpdate={this.handleTableUpdate.bind(this)}
        onRowAdd={this.handleAddEvent.bind(this)}
        onRowDel={this.handleRowDel.bind(this)}
        onSave={this.handleSaveEvent.bind(this)}
        funds={this.state.dataSource} />
    )
  }
}

export default EditableFunds
